import React from 'react'

import {
  useAPIGetKompetensiKategoriOptions,
  useAPIGetKompetensiKegiatanOptions,
} from 'api/kinerja/penilik-pegawai/perencanaan'

import type {
  PengembanganKompetensiKategori,
  PengembanganKompetensiKegiatan,
} from 'types/kinerja-penilik-pegawai'

type TPengembanganKompetensiHooks = {
  kompetensiKategoriData: PengembanganKompetensiKategori[]
  kompetensiKegiatanData: PengembanganKompetensiKegiatan[]
}
export const usePengembanganKompetensi = (
  kategoriId?: string
): TPengembanganKompetensiHooks => {
  const {
    data: kompetensiKategoriResponse,
    isSuccess: isKompetensiKategoriSuccess,
  } = useAPIGetKompetensiKategoriOptions()

  const {
    data: kompetensiKegiatanResponse,
    isSuccess: isKompetensiKegiatanSuccess,
  } = useAPIGetKompetensiKegiatanOptions({
    kategoriId,
    enabled: Boolean(kategoriId),
  })

  const kompetensiKategoriData = React.useMemo(() => {
    if (isKompetensiKategoriSuccess) {
      return kompetensiKategoriResponse?.data ?? []
    }

    return []
  }, [isKompetensiKategoriSuccess, kompetensiKategoriResponse?.data])

  const kompetensiKegiatanData = React.useMemo(() => {
    if (isKompetensiKegiatanSuccess) {
      return kompetensiKegiatanResponse?.data ?? []
    }

    return []
  }, [isKompetensiKegiatanSuccess, kompetensiKegiatanResponse?.data])

  return {
    kompetensiKategoriData,
    kompetensiKegiatanData,
  }
}
